'use client';

import BackgroundVideo from '@/components/background-video';

import heroPoster from '@images/hero-poster.webp';

// hero 배경 영상 — 공용 BackgroundVideo에 hero 파라미터 주입(1440/720, poster LCP 우선).
export default function HeroBackgroundVideo({
  className,
}: {
  className?: string;
}) {
  return (
    <BackgroundVideo
      poster={heroPoster}
      name="hero"
      wideRes="1440"
      narrowRes="720"
      priorityPoster
      className={className}
    />
  );
}
